import React from 'react'
import Tilt from 'react-parallax-tilt'

import { KnowOurSecretsLabels } from 'src/types'
import {
    CardSection,
    ContentButton,
    ImageContent,
    ImageSection,
    LinkDirection,
    RuteDirection,
    ImageVector,
    CardSectionResponsive,
} from './styles'
import { LineHeight25 } from 'src/components/common/Typography/typography'
import Vector from 'src/assets/KnowOurSecrets/Vector.avif'
import { useAnimation } from 'src/hook'
import { useTranslations } from 'src/provider/LocaleProvider'

export const MapSecrets = ({
    image,
    name,
    link,
    linkDirection,
    ruta,
    animation,
    background,
}: KnowOurSecretsLabels) => {
    const t = useTranslations()
    const { control, ref } = useAnimation({ initialSpriteIdTitle: 2 })

    const LinkButton = () => {
        if (link) {
            return (
                <LinkDirection
                    href={linkDirection}
                    target={'_blank'}
                    aria-label="Read more about Seminole tax hike"
                >
                    <LineHeight25
                        variant={'h2'}
                        fontSize={'xxmedium'}
                        fontWeight={700}
                    >
                        {t('cta.learnMore')}
                    </LineHeight25>
                    <ImageVector src={Vector} alt={'Vector'} />
                </LinkDirection>
            )
        } else {
            return (
                <RuteDirection to={`/${ruta}`}>
                    <LineHeight25
                        variant={'h2'}
                        fontSize={'xxmedium'}
                        fontWeight={700}
                    >
                        {t('cta.learnMore')}
                    </LineHeight25>
                    <ImageVector src={Vector} alt={'Vector'} />
                </RuteDirection>
            )
        }
    }
    const imageButton = () => {
        if (link) {
            return <LinkDirection href={linkDirection} target={'_blank'} />
        } else {
            return <RuteDirection to={`/${ruta}`} />
        }
    }
    return (
        <>
            <CardSection marginBottom={['xxmedium', 0, 0, 0]} ref={ref}>
                <Tilt>
                    <ImageContent
                        initial="hidden"
                        animate={control}
                        variants={animation}
                        background={background}
                    >
                        {imageButton()}
                        <ImageSection src={image} alt={name} />
                    </ImageContent>
                </Tilt>
                <ContentButton
                    marginTop={'xxxmedium'}
                    initial="hidden"
                    animate={control}
                    variants={animation}
                >
                    {LinkButton()}
                </ContentButton>
            </CardSection>
            <CardSectionResponsive marginBottom={['xxmedium', 0, 0, 0]}>
                <ImageContent background={background}>
                    {imageButton()}
                    <ImageSection src={image} alt={name} />
                </ImageContent>
                <ContentButton marginTop={'xxxmedium'}>
                    {LinkButton()}
                </ContentButton>
            </CardSectionResponsive>
        </>
    )
}
